import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-chat-3-line"></i>
            <span>读者评价</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            漫友心声 · 大家都在聊什么
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            来自真实读者的使用反馈和追漫感受
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {commentsData.map((comment, idx) => (
            <div
              key={idx}
              className={`bg-background-50 rounded-xl p-4 md:p-5 ${
                idx >= 3 ? 'hidden lg:block' : ''
              }`}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center font-bold text-sm flex-shrink-0">
                  {comment.avatar}
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground-800 truncate">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3">
                &ldquo;{comment.content}&rdquo;
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}